import React, { useEffect } from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import UserDataForm from "../../global-elements/userDataForm";
import ValidatorService from "../../../../services/validator";
import TC from "../../add-ons/TC";
import Esign from "../../add-ons/esign";
import "../../../../assets/terms/dm-terms.css";
import marketing from "../../../../services/marketing";
import Acknowledgements from "../../add-ons/Acknowledgements";
import CreditProtection from "../../add-ons/CreditProtection";
import OverlimitPrivilege from "../../add-ons/OverlimitPrivilege";
import ErrorModal from "../../../body/forms/components/ErrorModal";
import Recaptcha from "../../../body/forms/components/recaptcha/Recaptcha";
import InvalidStateModal from "../../global-elements/invalidStateModal";
import PixelsService from "../../../../services/pixels";
import AudioEyeSupport from "../../../../services/audioEyeSupport";
import ConfirmSmsConsent from "../../global-elements/confirmsSmsConsent";
import SubmitApplicationService from "../../../../services/submitApplication";
import Econsent from '../../global-elements/eConsent';
import AdobeScript from "../../../../services/adobeScript";
import AxiosWrapper from "../../../../services/axios";
import MfaSms from "../../global-elements/mfa/mfaSms";
import MfaEmail from "../../global-elements/mfa/mfaEmail";
import DeadEndMFa from "../../global-elements/mfa/deadEndMfa";
import Wildcard from "../../../../services/wildcard";
import FeaturesService from "../../../../services/features";
import { RESULTS } from "../../../../models/websiteTypesConstants";

function Apply() {
  const ada = new AudioEyeSupport();
  const Setting = useStoreState((state) => state.siteSettingsModel);
  const setGrandBanckDeclined = useStoreActions((actions) => actions.siteSettingsModel.setGrandBanckDeclined);
  const info = useStoreState((state) => state.applicantModel.applicant);
  const alResult = useStoreState((state) => state.alResult);
  const setAlResult = useStoreActions((actions) => actions.setAlResult);
  const Flow = useStoreState((state) => state.siteSettingsModel.mainSettings.Flow);
  const setInfo = useStoreActions((actions) => actions.applicantModel.setApplicant);
  const setApplicationResult = useStoreActions((actions) => actions.applicationResultModel.setApplicationResult);
  const resultStep = useStoreActions((actions) => actions.setDisplayResult);
  const history = useHistory();
  const getRoutingSettings = useStoreActions((state) => state.routingSettingsModel.getRoutingSettings);
  const [errorShow, setErrorShow] = useState(false);
  const closeError = () => setErrorShow(false);
  const InvalidState = useStoreState((state) => state.invalidState);
  const setInvalidState = useStoreActions((actions) => actions.setInvalidState);
  const [errorMessage, setErrorMessage] = useState(false);
  const validatorService = new ValidatorService();
  const methods = useForm({ mode: "onSubmit" });
  const [isLoading, setLoading] = useState(false);
  const adobeAds = new AdobeScript()
  const brandSettings = useStoreState((state) => state.siteSettingsModel.brandSettings);
  const MainPath = useStoreState((state) => state.siteSettingsModel.MainPath);
  const [recaptchaDisabled, setRecaptchaDisabled] = useState(true);
  const utms = new marketing();
  const features = new FeaturesService();
  const setInitPixels = useStoreActions((actions) => actions.setInitPixels);
  const initPixels = useStoreState((state) => state.initPixels);
  const PixelService = new PixelsService();
  const Submit = SubmitApplicationService();
  const WaterfallEvents = { "ACTIVATION_PAYMENT": 36 };
  const setDeclineOffers = useStoreActions(actions => actions.siteSettingsModel.setDeclineOffers);
  const [isHalfScrolled, setIsHalfScrolled] = useState(false);
  const domain = useStoreState(state => state.siteSettingsModel.domain);
  const wildcard = new Wildcard();
  const client = new AxiosWrapper()
  const setMfaSms = useStoreActions(actions => actions.setMfaSms);
  const [tcHasErrors, setTcHasErrors] = useState(false); //SECOND HERE
  const isRecaptchaBlocking = Setting.productSettings.CaptchaKey !== null && recaptchaDisabled;
  const isDisabled = isLoading || tcHasErrors || isRecaptchaBlocking; //FINAL HERE
  const showOverlimit = wildcard.isFeatureEnabled('OverlimitSettings');

  
  useEffect(() => {
    if (!initPixels) {
      utms.mapper();
      ada.setup();
      adobeAds.setup()
      setTimeout(() =>  adobeAds.startEvent('page_view'), 5000);
      utms.trackEvent(WaterfallEvents[Flow] || 0, Flow, "", Setting.productSettings.ProductId, "Flow");
      PixelService.initialize().pageView("/landing").event("google", "tracking", "Landing Page");
      getRoutingSettings({ Url: Setting.domain, Route: window.location.pathname });
      setInfo({ index : 'ProductCode', value : Setting.mainSettings.ProductCode })
      setInfo({ index : 'Url', value : domain });
      setInitPixels(true)
      setAlResult(false)
    }

  }, []);

  const validateSubmition = async (data) => {
        
    setLoading(true)

        ///////////////////////////////////
        if (!validatorService.preValidations(data, methods, info)) {
          if(await validatorService.EmailValidate(info.Email, methods)){
          if(await validatorService.addressValidateV2(info, methods, setInvalidState) === true){
                  if(wildcard.isFeatureEnabled('MFAActive')){
                    let mfaId = await client.get('/mfa-id',{})
                    sessionStorage.setItem('mfaId', mfaId);
                    console.log(mfaId)
                    let result = await client.post('/send-Mfa', {
                        contactIdentifier : info.PrimaryPhone,
                        contactType : 'Text', 
                        ApplicantId : 0,
                        WebUrl : Setting.domain
                        }, true)
                    if(result && result.Success === true){
                        sessionStorage.setItem('sessionToken', result.Payload)
                        setMfaSms(true)
                        return
                    }
                    setErrorShow(true);
                    setErrorMessage('An unknown error has occured. Please try again.')
                    return
                }else{
                await submit();
                }
          
          }
          }
        }
    setLoading(false)
  };

  useEffect(() => {
    const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const fullHeight = document.body.scrollHeight;
    const scrolledToBottom = scrollPosition + windowHeight;

    if (scrolledToBottom >= fullHeight / 2) {
      console.log()
      if(isHalfScrolled === false){
          
          setIsHalfScrolled(true)
      }
      
    }
  };

  window.addEventListener('scroll', handleScroll);

  return () => {
      window.removeEventListener('scroll', handleScroll);
  };
  }, [isHalfScrolled]);

  useEffect(() => {
  if (isHalfScrolled) {
      scrollEvent();
  }
  }, [isHalfScrolled]);

  const scrollEvent = () => {
  adobeAds.event('scroll')
  };

  async function submit() {

    let response = await Submit.submitApplication(info, true);
    let payload = response.Payload;
    adobeAds.event('apply_now_click')
    if (response.Success) {
      if (payload) {
        if (payload.IsGrandbank === true) { setGrandBanckDeclined(true) }
        window.cl = response.credit_limit ?? 0;
        if (payload.result != null) {
          utms.updateAppId(payload.ref_number || "");
          if (payload.result) {
            utms.updateSessionReport("appResult", payload.result.toUpperCase());
          }
          if (payload.ref_number) {
            utms.updateSessionReport("applicantId", payload.ref_number);
          }

           //Decline Offers for BMG box
          setDeclineOffers(payload.DeclineOffers || null);

          setInfo({ index: "step", value: 3 });
          setApplicationResult(payload);
          resultStep(true);
          window.scrollTo(0, 0);

          if (payload.result.toUpperCase() === RESULTS.PENDFEE && Setting.brandSettings.ProductName.toLowerCase() === "fit") {
            if (alResult === false) {
              PixelService.pageView(MainPath + "approved").approvedCalls(
                payload.ref_number
              );

              utms.trackEvent(
                WaterfallEvents[Flow] || 0,
                Flow,
                payload.ref_number,
                Setting.productSettings.ProductId,
                "Flow"
              );

              setAlResult(true);
            }
            history.push(MainPath + "pendfee");
            return;
          }

          //New Bank Account call for Dynamic call
          if((Flow === 'DM' || features.isLinkBankAccountFeatureEnabled()) && payload.result.toUpperCase() === RESULTS.PENDUSER) {
            history.push(MainPath + "link-account" + window.location.search); return;
          }
          //--------------//
          
          if (payload.result.toUpperCase() === RESULTS.APPROVED) {
            history.push(MainPath + "approvedmla" + window.location.search);
            return;
          }
          if (RESULTS.PENDINFO.includes(payload.result.toUpperCase())) {
            history.push(MainPath + "pendinfo" + window.location.search);
            return;
          }
          history.push(MainPath + "decision" + window.location.search);
          return;
        }
      } else {
        setErrorMessage("An unknown error has occured. Please try again.");
        setErrorShow(true);
        setLoading(false);
      }
    }
    else {
      payload.decline_message='We are currently processing your application, and you will receive a decision within 30 days.'
      setInfo({ index: "step", value: 3 });
      setApplicationResult(payload);
      resultStep(true);
      window.scrollTo(0, 0);
      history.push(MainPath + "decision" + window.location.search);
      return;
    }
  }

  return (
    <>
     {/*--- MFA stuff ---*/}
       {(wildcard.isFeatureEnabled('MFAActive')) && (
              <>
                  <MfaSms />
                  <MfaEmail />
                  <DeadEndMFa />
              </>
              
        )}
      {/*--- END MFA stuff ---*/}
      <ErrorModal
        size="sm"
        show={errorShow}
        message={errorMessage}
        closeError={closeError}
      />
      <InvalidStateModal visible={InvalidState} />
      <div className="container mt-5 mb-5">
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(validateSubmition)}>
            <div className="dm-form">
              <UserDataForm />
            </div>

            <div className="row">
              <div className="col-12">
                <h1 className="terms-header-title">E-Sign Disclosure</h1>
              </div>
              <Esign />
            </div>
            <div className="row">
              <div className="col-12">
                <h1 className="terms-header-title">Pricing and Terms</h1>
              </div>
              <div className="col-12 ">
                <div className="terms-wrapper">
                  <TC
                    data={{ productCode: Setting.mainSettings.ProductCode }} onTermsErrorChange={setTcHasErrors} //THIRD HERE
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <h1 className="terms-header-title">Credit Protection</h1>
              </div>
              <CreditProtection />
            </div>

            {showOverlimit && (
              <div className="row">
                <div className="col-12">
                  <h1 className="terms-header-title">Overlimit Privilege</h1>
                </div>
                <OverlimitPrivilege />
              </div>
            )}
            <div className="row">
              <div className="col-12">
                <h1 className="terms-header-title">Acknowledgements</h1>
              </div>
              <Econsent />
              {Setting.smsConcentModuleCFC === true && (
                <div className="col-12 mb-3">
                    <div className="col-12">
                        <ConfirmSmsConsent></ConfirmSmsConsent>
                    </div>
                </div>
            )}
              <Acknowledgements data={{ productCode: Setting.mainSettings.ProductCode }} />
            </div>
            <div className="row ">
              <div className="captcha-container">
                {Setting.productSettings.CaptchaKey !== null ? (
                  <div className="form-group displayFlexCenter">
                    <Recaptcha
                      setRecaptchaDisabled={setRecaptchaDisabled}
                      ProductName={brandSettings.ProductName}
                    />
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-12 text-center">
                <button
                  disabled={isDisabled}
                  id="payment-submit-app"
                  style={{ 
                    backgroundColor: Setting.brandSettings.BannerBgColor, 
                    width: "auto",
                    opacity: isLoading ? 0.5 : 1, 
                    marginTop: "1.5em",
                    border: "1px solid transparent",
                    color: "white"
                  }}
                  onClick={() => {
                    adobeAds.event('form_submit')
                  }}
                  className="pay-processing-button"
                  type="submit"
                >
                  {isLoading ? 'Submitting...' : (wildcard.isFeatureEnabled('MFAActive') ? 'Verify and Submit' : 'Submit Application') }
                </button>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </>
  );
}

export default Apply;
